import { useProductStore } from '@/stores';
import { RouteLocationNormalized } from '#vue-router';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  const { productHistory, resetProductHistory } = useProductStore();
  const { route: previousRoute } = productHistory;

  const listingPages = ['kategorier-slug', 'search'];
  if (!listingPages.includes(to.name as string)) return;

  if (
    from?.name !== 'produkt-slug' ||
    previousRoute?.name !== to.name ||
    (previousRoute?.name === to.name && previousRoute?.path !== to.fullPath)
  ) {
    resetProductHistory();
  }

  if (to.name === 'search') {
    const hasQuery = to?.query.q?.toString().trim().length;
    if (!hasQuery) navigateTo('/', { replace: true });
  }
});
